import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca34e0dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-triage-page" }
const _hoisted_2 = {
  key: 1,
  class: "nge-triage-page-msg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-triage-page-title" }, "Sign in to EyeWire II first", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "The triage board uses the sign-in from the game in this browser.", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.state === 'ready')
      ? (_openBlock(), _createBlock($setup["AdminHub"], {
          key: 0,
          "initial-sub-tab": "triage",
          standalone: ""
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.state === 'checking')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Opening the triage board…")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("a", {
                  class: "nge-triage-page-link",
                  href: $setup.gameUrl
                }, "Open EyeWire II")
              ], 64 /* STABLE_FRAGMENT */))
        ]))
  ]))
}